<div class="approw">
	<footer id="footer-bar" class="footer-content-bar ml-0">
		<p id="footer-copyright">Powered by 4dot5</p>
	</footer>
</div>